import { render, staticRenderFns } from "./ManualPolicyRenewal.vue?vue&type=template&id=2b6b9d9a"
import script from "./ManualPolicyRenewal.vue?vue&type=script&lang=js"
export * from "./ManualPolicyRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports